import { GOOGLE_API_KEY } from '@/constants';
import axios from 'axios';
import _default from 'gmap-vue';

export default class GeoLocationService {
  private async getLocation() {
    return new Promise((resolve, reject) => {
      if (!('geolocation' in navigator)) {
        reject(new Error('Geolocation is not available.'));
      }

      navigator.geolocation.getCurrentPosition(
        pos => {
          resolve(pos);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  public getUserLocation(): Promise<any> {
    return this.getLocation().then((result: GeolocationPosition) => this.geocodeLatLng(result.coords.latitude, result.coords.longitude));
  }

  private geocodeLatLng(lat, lng) {
    const geocoder = new google.maps.Geocoder();
    return geocoder.geocode(
      { location: { lat, lng } },
      (results: google.maps.GeocoderResult[], status: google.maps.GeocoderStatus) => status === 'OK' && results[0] && results
    );
  }
}
